import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {useGetSelfServiceFlowLevelTitle} from '../hooks/useGetSelfServiceFlow';
import {SelfServiceFlowTitleView} from './SelfServiceFlowTitleView';

export const SelfServiceFlowTitle = ({small}: {small?: boolean}) => {
  return (
    <DataFetcher
      request={useGetSelfServiceFlowLevelTitle()}
      View={SelfServiceFlowTitleView}
      viewProps={{small}}
      Error={() => null}
      Loading={() => (
        <SkeletonBlock style={{marginTop: 40}} $width="50%" $height="40px" />
      )}
    />
  );
};
